export const KEYWORD = "keywords.query.bar.edit.keyword.title";
export const SEARCH_TERM = "keywords.query.bar.edit.keyword.searchTerm";
export const KEYWORD_GROUP = "keywords.query.bar.edit.keyword.group.title";
export const TOPICS_SECONDARY_TEXT = "keywords.query.bar.secondary.text.topics";

export const KEYWORD_TOOLTIP = "keywords.query.bar.open.google.search.tooltip";
export const ADD_TO_GROUP_TOOLTIP = "keywords.query.bar.addToGroup";
export const AUTO_CERATE_KEYWORD_LIST = "keywords.query.bar.autoCreateKeywordList.tooltip";
export const EDIT_TOOLTIP = "keywords.query.bar.edit.keyword.group.tooltip";
